import React from "react";
import { IconButton, makeStyles } from "@material-ui/core";
import HeaderD from "../assets/Header/cameraDesktop@2x.png";
import HeaderM from "../assets/Header/cameraMobilec.png";
import LogoD from "../assets/Header/Grupo 45@2x.png";
import Face from "../assets/Header/face.png";
import Youtube from "../assets/Header/Icon ionic-logo-youtube@2x.png";
import Instagram from '@material-ui/icons/Instagram';

export default function Header() {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <div className={classes.desktop}>
        <div className={classes.content}>
          <a href="/">
            <img src={LogoD} alt="Logo" className={classes.logo} />
          </a>
        </div>
        <div className={classes.links}>
          <a
            href="https://www.facebook.com/roberto.murilo/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={Face} alt="Face" className={classes.face} />
          </a>
          <a 
            href="https://www.youtube.com/channel/UCiwgM3ZmdPPrPveLrh7G-UA"
            target="_blank"
            rel="noopener noreferrer"
            >
            <img src={Youtube} alt="Youtube" className={classes.youtube} />
          </a>
          <IconButton style={{padding:0}}>
            <a 
              href="https://www.instagram.com/arq.robertomurilo/"
              target="_blank"
              rel="noopener noreferrer"
              >
                <Instagram className={classes.insta}/>
            </a>
          </IconButton>

        </div>
      </div>
      <div className={classes.mobile}>
        <a href="/">
          <img src={LogoD} alt="Logo" className={classes.logoM} />
        </a>
        <div className={classes.linksM}>
          <a 
          href="https://www.facebook.com/roberto.murilo/"
          target="_blank"
          rel="noopener noreferrer"
          >
            <img src={Face} alt="Face" className={classes.faceM} />
          </a>
          <a 
          href="https://www.youtube.com/channel/UCiwgM3ZmdPPrPveLrh7G-UA"
          target="_blank"
          rel="noopener noreferrer"
          >
            <img src={Youtube} alt="Youtube" className={classes.youtubeM} />
          </a>
          <IconButton style={{padding:0}}>
            <a 
              href="https://www.instagram.com/arq.robertomurilo/"
              target="_blank"
              rel="noopener noreferrer"
              >
                <Instagram className={classes.instaM}/>
            </a>
          </IconButton>
        </div>
      </div>
      <div className={classes.espacoM} />
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100vw",
  },
  desktop: {
    backgroundImage: `url(${HeaderD})`,
    height: "100%",
    width: "100%",
    backgroundPosition: "center",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    justifyContent: "space-between",
    display: "flex",
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  mobile: {
    top: 0,
    zIndex: "1000",
    position: "fixed",
    backgroundImage: `url(${HeaderM})`,
    height: "21.6vw",
    width: "100vw",
    backgroundPosition: "center",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    justifyContent: "space-between",
    alignItems: "center",
    display: "flex",
    boxShadow: "0px 3px 6px #0000009E",
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },
  content: {
    marginTop: "0.9vw",
    paddingBottom: "1.8vw",
    alignItems: "center",
    flexDirection: "column",
    display: "flex",
  },
  contentM: {
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    display: "flex",
  },
  nome: {
    font: "Karla",
    fontSize: "1.5vw",
    color: theme.colors.gray2,
    paddingBottom: "1.5vw",
  },
  nomeM: {
    font: "Karla",
    fontSize: "2.6vw",
    color: theme.colors.gray2,
    paddingBottom: "3.7vw",
  },
  logo: {
    height: "11.7vw",
  },
  logoM: {
    height: "18.9vw",
  },
  face: {
    height: "3.1vw",
  },
  faceM: {
    height: "6.36vw",
  },
  youtube: {
    height: "2.27vw",
  },
  youtubeM: {
    height: "4.75vw",
  },
  insta: {
    height: "50px",
    width: "50px",
    color: "#f8f8fc"
  },
  instaM: {
    height: "5.75vw",
    color: "#f8f8fc"
  },
  links: {
    alignSelf: "flex-start",
    alignItems: "center",
    justifyContent: "center",
    marginTop: "1.6vw",
    marginRight: "3.4vw",
    gap: "1.5vw",
    display: "flex",
  },
  linksM: {
    alignSelf: "flex-start",
    alignItems: "center",
    justifyContent: "center",
    marginTop: "3.2vw",
    marginRight: "4vw",
    gap: "2.22vw",
    display: "flex",
  },
  link: {},
  espacoM: {
    height: "21.6vw",
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },
}));
